(() => {
  function initSection(section) {
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';
    document.body.classList.add('up-review-claim-page');

    const ratingStep = section.querySelector('[data-rating-step]');
    const claimStep = section.querySelector('[data-claim-step]');
    const thanksStep = section.querySelector('[data-parent-thanks-step]');

    const ratingButtons = section.querySelectorAll('[data-rating-value]');
    const ratingButtonsWrap = section.querySelector('.up-review-claim__rating-buttons');
    const selectedRating = section.querySelector('[data-selected-rating]');
    const backButton = section.querySelector('[data-claim-back]');
    const trustpilotButton = section.querySelector('[data-trustpilot-button]');
    const globoWrap = section.querySelector('[data-globo-claim-form]');

    const lowRatingUrl = (section.dataset.lowRatingUrl || '').trim();
    const highRatingUrl = (
      section.dataset.highRatingUrl ||
      'https://www.trustpilot.com/evaluate/ultimapeak.com'
    ).trim();

    let activeRating = 0;
    let successHandled = false;
    let successTimer = null;

    function paintRating(rating) {
      if (!selectedRating) return;

      selectedRating.innerHTML = '';

      for (let i = 1; i <= 5; i += 1) {
        const star = document.createElement('span');
        star.textContent = '★';
        star.style.opacity = i <= rating ? '1' : '.2';
        star.setAttribute('aria-hidden', 'true');
        selectedRating.appendChild(star);
      }
    }

    function hideAllSteps() {
      if (ratingStep) ratingStep.hidden = true;
      if (claimStep) claimStep.hidden = true;
      if (thanksStep) thanksStep.hidden = true;
    }

    function cleanParams(url) {
      url.searchParams.delete('claim');
      url.searchParams.delete('rating');
      url.searchParams.delete('claim_success');
    }

    function showRating(updateUrl = true) {
      activeRating = 0;
      successHandled = false;

      hideAllSteps();

      if (ratingStep) ratingStep.hidden = false;

      if (updateUrl) {
        const url = new URL(window.location.href);
        cleanParams(url);
        window.history.replaceState({}, '', url.toString());
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function showClaim(rating, updateUrl = true) {
      activeRating = Number(rating) || 0;
      successHandled = false;

      hideAllSteps();

      if (claimStep) claimStep.hidden = false;

      paintRating(activeRating);

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.delete('claim_success');
        url.searchParams.set('claim', '1');
        url.searchParams.set('rating', String(activeRating));
        window.history.replaceState({}, '', url.toString());
      }

      syncGloboRating();

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function showThanks() {
      if (successHandled) return;

      successHandled = true;

      if (successTimer) {
        clearInterval(successTimer);
        successTimer = null;
      }

      hideAllSteps();

      if (thanksStep) thanksStep.hidden = false;

      const url = new URL(window.location.href);
      cleanParams(url);
      window.history.replaceState({}, '', url.toString());

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function openInNewTab(url) {
      if (!url) return false;

      const newTab = window.open(url, '_blank');

      if (!newTab) return false;

      try {
        newTab.opener = null;
      } catch (error) {
        // Nothing required.
      }

      return true;
    }

    function clearRatingHover() {
      ratingButtons.forEach((button) => {
        button.classList.remove('is-rating-active');
        button.classList.remove('is-rating-current');
      });

      section.classList.remove('is-rating-hovering');
    }

    function setRatingHover(rating) {
      section.classList.add('is-rating-hovering');

      ratingButtons.forEach((button) => {
        const value = Number(button.dataset.ratingValue || 0);

        button.classList.toggle(
          'is-rating-active',
          value <= rating
        );

        button.classList.toggle(
          'is-rating-current',
          value === rating
        );
      });
    }

    ratingButtons.forEach((button) => {
      const rating = Number(button.dataset.ratingValue || 0);

      button.addEventListener('mouseenter', () => {
        setRatingHover(rating);
      });

      button.addEventListener('focus', () => {
        setRatingHover(rating);
      });

      button.addEventListener('blur', clearRatingHover);

      button.addEventListener('click', () => {
        clearRatingHover();

        if (rating >= 1 && rating <= 3) {
          if (!lowRatingUrl) {
            console.warn('UltimaPeak: Judge.me URL is missing.');
            return;
          }

          const opened = openInNewTab(lowRatingUrl);

          if (!opened) {
            window.location.assign(lowRatingUrl);
          }

          return;
        }

        if (rating === 4 || rating === 5) {
          showClaim(rating, true);
        }
      });
    });

    if (ratingButtonsWrap) {
      ratingButtonsWrap.addEventListener(
        'mouseleave',
        clearRatingHover
      );
    }

    if (trustpilotButton && highRatingUrl) {
      trustpilotButton.href = highRatingUrl;
      trustpilotButton.target = '_blank';
      trustpilotButton.rel = 'noopener noreferrer';
    }

    function normalize(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    /*
      Recommended:
      In Powerful Form Builder add a Hidden field with label "Rating".
      This code fills it with the 4/5 selected on this page.
    */
    function syncGloboRating() {
      if (!globoWrap || !activeRating) return;

      globoWrap
        .querySelectorAll('.globo-form-control')
        .forEach((control) => {
          const label = control.querySelector(
            '.label-content, [data-label], label'
          );

          const labelText = normalize(
            label?.dataset?.label || label?.textContent
          );

          if (labelText !== 'rating') return;

          const field = control.querySelector(
            'input:not([type="file"]):not([type="submit"]):not([type="button"]), textarea, select'
          );

          if (!field) return;

          field.value = String(activeRating);
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
        });

      globoWrap
        .querySelectorAll('input[type="hidden"]')
        .forEach((input) => {
          const identity = normalize(
            [
              input.name,
              input.id,
              input.dataset?.label,
              input.dataset?.name
            ]
              .filter(Boolean)
              .join(' ')
          );

          if (!identity.includes('rating')) return;

          input.value = String(activeRating);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    function isVisible(element) {
      if (!element) return false;

      const style = window.getComputedStyle(element);

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number(style.opacity) === 0
      ) {
        return false;
      }

      const rect = element.getBoundingClientRect();

      return rect.width > 0 && rect.height > 0;
    }

    function getVisibleGloboSuccess() {
      if (!globoWrap) return null;

      const selectors = [
        '.globo-form-app .message.success',
        '.globo-form-app .success-message',
        '.globo-form-app [data-success-message]',
        '.globo-form-app .alert-success'
      ];

      return Array.from(
        globoWrap.querySelectorAll(selectors.join(','))
      ).find((element) => {
        return (
          isVisible(element) &&
          element.textContent.trim().length > 0
        );
      });
    }

    function checkGloboSuccess() {
      if (successHandled) return;

      if (getVisibleGloboSuccess()) {
        showThanks();
      }
    }

    function startSuccessPolling() {
      if (successTimer) {
        clearInterval(successTimer);
      }

      let checks = 0;

      successTimer = setInterval(() => {
        checks += 1;

        syncGloboRating();
        checkGloboSuccess();

        if (successHandled || checks >= 120) {
          clearInterval(successTimer);
          successTimer = null;
        }
      }, 250);
    }

    if (globoWrap) {
      const observer = new MutationObserver(() => {
        syncGloboRating();
        checkGloboSuccess();
      });

      observer.observe(globoWrap, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'hidden',
          'aria-hidden'
        ]
      });

      globoWrap.addEventListener(
        'submit',
        (event) => {
          if (!event.target.closest('form')) return;

          syncGloboRating();
          startSuccessPolling();
        },
        true
      );

      syncGloboRating();
    }

    const params = new URLSearchParams(window.location.search);

    if (params.get('claim_success') === '1') {
      showThanks();
      return;
    }

    const urlRating = Number(params.get('rating') || 0);

    if (
      params.get('claim') === '1' &&
      (urlRating === 4 || urlRating === 5)
    ) {
      showClaim(urlRating, false);
    } else {
      showRating(false);
    }

    if (backButton) {
      backButton.addEventListener('click', () => {
        clearRatingHover();
        showRating(true);
      });
    }

    window.addEventListener('popstate', () => {
      const nextParams = new URLSearchParams(window.location.search);

      if (nextParams.get('claim_success') === '1') {
        successHandled = false;
        showThanks();
        return;
      }

      const nextRating = Number(nextParams.get('rating') || 0);

      if (
        nextParams.get('claim') === '1' &&
        (nextRating === 4 || nextRating === 5)
      ) {
        showClaim(nextRating, false);
      } else {
        showRating(false);
      }
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-up-review-claim]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-up-review-claim]');

    if (section) {
      initSection(section);
    }
  });
})();
